module.exports = __webpack_public_path__ + "img/blog-cover-themes.07b56aa1.webp";